exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label_position label{margin-bottom:.2rem}.v-application--wrap{min-height:1vh}.v-application{font-family:Mulish}", ""]);

// exports
